<script>
import idealLayPercentages from '@/layerAdmin/data/idealData.js';
import BatchesCheckboxes from '@/layerAdmin/components/BatchesCheckboxes.vue';
import LayPercentageVsFoodChart from '@/layerAdmin/components/LayPercentageVsFoodChart.vue';

export default {
  components: {
    BatchesCheckboxes,
    LayPercentageVsFoodChart,
  },

  props: {
    batches: { type: Array, required: true },
  },

  data: function () {
    let actualMinimumWeeks = Math.min(...this.batches.map(x => Math.min(...x.records.map(y => y.age_in_weeks))));
    let actualMaximumWeeks = Math.max(...this.batches.map(x => Math.max(...x.records.map(y => y.age_in_weeks))));

    return {
      showFiltering: false,

      actualMinimumWeeks: actualMinimumWeeks,
      actualMaximumWeeks: actualMaximumWeeks,

      visibleBatchNames: this.batches.map(x => x.name),
      chosenMinimumWeeks: actualMinimumWeeks,
      chosenMaximumWeeks: actualMaximumWeeks,

      availableSeries: [
        { name: 'Lay %', show: true },
        { name: 'Feed/hen', show: true },
        { name: 'Avg g/egg', show: true },
      ],

      idealLayPercentageTypes: Object.keys(idealLayPercentages).map(x => ({ text: x, value: x })),
      visibleIdealLayPercentageTypes: [],
    };
  },

  computed: {
    isFiltered() {
      return this.visibleBatchNames.length < this.batches.length ||
        Number(this.chosenMinimumWeeks) !== Number(this.actualMinimumWeeks) ||
        Number(this.chosenMaximumWeeks) !== Number(this.actualMaximumWeeks);
    },

    filterIconOpacity() {
      if (this.isFiltered && this.showFiltering) return 1;
      if (this.isFiltered) return 0.7;
      else if (this.showFiltering) return 0.7;
      else return 0.2;
    },

    colorPairsPerBatch() {
      let nextColorPair = (function () {
        let colorPairs = [
          ['#665180', '#ccc1da'],
          ['#4f6228', '#c3d69b'],
          ['#a8423f', '#d99694'],
          ['#31859c', '#b7dee8'],
          ['#000000', '#777777'],
          ['#ff7800', '#ffb472'],
        ];
        let index = -1;
        return function () {
          if (index + 1 > colorPairs.length - 1) {
            index = -1;
          }
          index++;
          return colorPairs[index];
        }
      })();

      let pairsPerBatch = {};
      this.batches.forEach(batch => { pairsPerBatch[batch.id] = nextColorPair() });
      return pairsPerBatch;
    },

    visibleBatches() { return this.batches.filter(x => this.visibleBatchNames.includes(x.name)) },
    visibleSeries() { return this.availableSeries.filter(x => x.show).map(x => x.name) },
  },

  methods: {
    resetFilter() {
      this.visibleBatchNames = this.batches.map(x => x.name);
      this.chosenMinimumWeeks = this.actualMinimumWeeks;
      this.chosenMaximumWeeks = this.actualMaximumWeeks;
    },
  },
}
</script>

<template>
  <div>
    <b-card class="mb-3">
      <div class="h3 m-0 text-center"> Admin Overview Reports </div>
    </b-card>

    <b-card class="mb-3">
      <div class="d-flex align-items-center">

        <div class="h5 m-0"> Overview Charts </div>

        <div class="ml-auto">
          <div class="h4 clickable" @click="showFiltering=!showFiltering">
            <i class="fa fa-filter filtering-icon" :class="{'text-warning': isFiltered}" :style="{opacity: filterIconOpacity}"></i>
          </div>
        </div>

      </div>

      <div v-if="showFiltering" class="mt-4">
        <div class="row">
          <div class="col-12 col-md-6">
            <b-form-group label="Minimum age (in weeks)" :label-for="`min-age-${_uid}`">
              <b-form-input :id="`min-age-${_uid}`" v-model="chosenMinimumWeeks" type="number" @focus="$event.target.select()"></b-form-input>
            </b-form-group>
          </div>

          <div class="col-12 col-md-6">
            <b-form-group label="Maximum age (in weeks)" :label-for="`max-age-${_uid}`">
              <b-form-input :id="`max-age-${_uid}`" v-model="chosenMaximumWeeks" type="number" @focus="$event.target.select()"></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-md-6">
            <batches-checkboxes v-model="visibleBatchNames" group-label="Shown Batches" :batches="batches" />
          </div>

          <div class="col-12 col-md-6">
            <b-form-group label="Shown series">
              <b-form-checkbox v-for="series in availableSeries" :key="series.name" v-model="series.show" inline> {{series.name}} </b-form-checkbox>
            </b-form-group>

            <b-form-group label="Ideal lay %">
              <b-form-checkbox-group v-model="visibleIdealLayPercentageTypes" :options="idealLayPercentageTypes" class="text-capitalize" />
            </b-form-group>
          </div>
        </div>

        <div class="mt-3 text-center">
          <a href="javascript:void(0)" class="text-muted" @click="resetFilter">
            <i class="fa fa-undo"></i>
            Reset filter
          </a>
        </div>
      </div>

      <lay-percentage-vs-food-chart
        :batches="visibleBatches"
        :color-pairs-per-batch="colorPairsPerBatch"
        :series="visibleSeries"
        :min-weeks="chosenMinimumWeeks"
        :max-weeks="chosenMaximumWeeks"
        :ideal-lay-percentage-types="visibleIdealLayPercentageTypes"
        class="mt-5" />
    </b-card>

  </div>
</template>

<style scoped>
.filtering-icon {
  transition: opacity 0.1s ease;
}
</style>



// WEBPACK FOOTER //
// src/layerAdmin/components/AdminOverviewReports.vue